import type { FC } from "react";

import { type MentionTarget, getMentionTooltipId } from "./mentions";

import { InitialsAvatar } from "mds/components/InitialsAvatar";
import { Tooltip } from "mds/components/Tooltip";

type UserMentionTarget = Extract<MentionTarget, { kind: "user" }>;

export const MentionIdentityTooltip: FC<{
  scopeId: string;
  target: UserMentionTarget;
}> = ({ scopeId, target }) => (
  <Tooltip
    anchorSelect={`[data-chat-mention-tooltip-scope="${scopeId}"][data-chat-mention-target-id="${target.id}"]`}
    content={
      <div className="flex max-w-64 items-center gap-2 text-left">
        <InitialsAvatar
          aria-hidden="true"
          className="bg-blue-tint-95"
          initials={target.initials}
          size="m"
        />
        <div className="min-w-0">
          <div className="truncate font-semibold text-black-tint-20">{target.displayName}</div>
          <div className="truncate text-xs text-black-tint-40">{target.email}</div>
        </div>
      </div>
    }
    id={getMentionTooltipId(scopeId, target.id)}
    kind="card"
    place="top"
  />
);
